import { Helmet } from 'react-helmet-async';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Permission } from '@/models/user';
import { PageWithLayout } from '@/models/page';
import { UserManagementContent } from '@/pages/userManagement/components/UserManagementContent';

const UserManagementPage: PageWithLayout = () => {
    return (
        <>
            <Helmet>Benutzerverwaltung | Starjack Admin</Helmet>

            <UserManagementContent />
        </>
    );
};

UserManagementPage.isProtected = true;
UserManagementPage.permissions = [Permission.DATA_MANAGEMENT_NAV];
UserManagementPage.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;

export default UserManagementPage;
